<form [formGroup]="form">
  <!-- NAME -->
  <mat-form-field class="width-100-percent">
    <mat-label translate="metric-reports/list/report-title"></mat-label>
    <input type="text" matInput formControlName="name" />
    <mat-error *ngIf="form.controls.name.errors?.required" translate="common/form_errors/required"></mat-error>
  </mat-form-field>
  <div class="selects">
    <!-- VARYING CRITERION -->
    <mat-form-field *ngIf="this.report.metric_id" class="width-50-percent">
      <mat-label translate="metric-reports/edition/varying-criterion"></mat-label>
      <mat-select formControlName="dateFieldToVary">
        <mat-option *ngFor="let dateCriteria of report.ui.dateCriteria" [value]="dateCriteria.selectorName">{{
          dateCriteria.label
        }}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.controls.dateFieldToVary.errors?.required" translate="common/form_errors/required">
      </mat-error>
    </mat-form-field>
    <!-- PERIODICITY -->
    <mat-form-field class="width-50-percent">
      <mat-label translate="metric-reports/edition/varying-frequency"></mat-label>
      <mat-select formControlName="periodicity">
        <mat-option *ngFor="let periodicity of periodicities" [value]="periodicity">
          <span [translate]="'metric-reports/list/periodicity/' + periodicity.key"></span>
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.controls.periodicity.errors?.required" translate="common/form_errors/required">
      </mat-error>
    </mat-form-field>
  </div>
  <!-- EMAIL -->
  <mat-checkbox formControlName="email" class="checkbox-email" aria-label="receive by email">
    <span translate="metric-reports/edition/receive-by-email"></span>
  </mat-checkbox>
  <!-- FTP -->
  <div *ngIf="isAdmin" class="ftp fixed-height">
    <mat-checkbox formControlName="ftp" #ftp class="checkbox-ftp" aria-label="receive by ftp">
      <span translate="metric-reports/edition/receive-by-ftp"></span>
    </mat-checkbox>
    <div class="select-ftp-with-errors">
      <app-select
        *ngIf="ftp.checked"
        class="select-ftp"
        [control]="form.controls.ftpConfigId"
        [items]="sftpServersItems"
        labelKey="metric-reports/edition/sftp-servers-list"
        [formFieldClass]="'no-vertical-padding'">
      </app-select>
      <mat-error *ngIf="form.controls.ftpConfigId.errors?.required" translate="common/form_errors/required">
      </mat-error>
    </div>
  </div>
  <!-- ONLY ME -->
  <div class="only-me fixed-height">
    <div class="checkbox-only-me">
      <span class="label-create-for" translate="metric-reports/edition/create-for"></span>
      <mat-checkbox formControlName="onlyForMe" #onlyForMe aria-label="only me">
        <span translate="metric-reports/edition/only-me"></span>
      </mat-checkbox>
    </div>
    <div class="select-users-with-error">
      <app-select
        *ngIf="!onlyForMe.checked"
        [control]="form.controls.createdForUsers"
        [items]="nonBotUsersItems"
        [multiple]="true"
        [panelClass]="'reports-configure-select-creator-overlay'"
        [formFieldClass]="'no-vertical-padding'">
      </app-select>
      <mat-error *ngIf="form.controls.createdForUsers.errors?.required" translate="common/form_errors/required">
      </mat-error>
    </div>
  </div>
</form>
